import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import React from 'react'
import {createRoot} from 'react-dom/client';
import { applyMiddleware, compose } from 'redux'
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { Provider } from 'react-redux'
import thunk from 'redux-thunk';
import logger from 'redux-logger'
import "src/custom/flavepalfingeroft2021/exhibition/stylesheet.scss"
//import cablecar from 'redux-cablecar'
import rootReducer from 'virtual_congress/exhibition_actions'
import ErrorBoundary from 'src/error_boundary.jsx'
import App from 'src/custom/flavepalfingeroft2021/exhibition/index.jsx'
'use strict';
import { HashRouter } from "react-router-dom";
import { createHashHistory } from "history";

import WebsocketConnection from 'src/shared/service/websocket_connection'

const history = createHashHistory();

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react_container')
  
  let dataState = JSON.parse(node.getAttribute('data'))
  console.log("dataState", dataState)
  // Add optional initial state
  let initialState = $.extend({}, dataState, {
  })

  console.log("Initial State", initialState)
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware(), logger], // cablecar, sentryReduxEnhancer, Sentry.createReduxEnhancer
    preloadedState: initialState
  })

  

  // cablecar.connect(store, 'AccountOrganizationChannel', {
  //   params: { },
  //   prefix: 'CABLE_ACCOUNT_ORGANIZATION'
  // });
  // cablecar.connect(store, 'SupportChatSessionChannel', {
  //   params: { },
  //   prefix: 'CABLE_SUPPORT_CHAT_SESSION'
  // });
  // cablecar.connect(store, 'SupportChatMessageChannel', {
  //   params: { },
  //   prefix: 'CABLE_SUPPORT_CHAT_MESSAGE'
  // });
  // cablecar.connect(store, 'ImageMapChannel', {
  //   params: { },
  //   prefix: 'CABLE_IMAGE_MAP_MESSAGE'
  // });
  // cablecar.connect(store, 'ImageHotspotChannel', {
  //   params: { },
  //   prefix: 'CABLE_IMAGE_HOTSPOT_MESSAGE'
  // });
  // cablecar.connect(store, 'ImageMapConfigChannel', {
  //   params: { },
  //   prefix: 'CABLE_IMAGE_MAP_CONFIG_MESSAGE'
  // });
  // cablecar.connect(store, 'ImageHotspotConfigChannel', {
  //   params: { },
  //   prefix: 'CABLE_IMAGE_HOTSPOT_CONFIG_MESSAGE'
  // });
  // cablecar.connect(store, 'MediaFileChannel', {
  //   params: { },
  //   prefix: 'CABLE_MEDIA_FILE_MESSAGE'
  // });
  // cablecar.connect(store, 'EventChannel', {
  //   params: { },
  //   prefix: 'CABLE_EVENT'
  // });
  // cablecar.connect(store, 'EventQuestionChannel', {
  //   params: { },
  //   prefix: 'CABLE_EVENT_QUESTION'
  // });

  // cablecar.connect(store, 'ChatMessageChannel', {
  //   params: { },
  //   prefix: 'CABLE_CHAT_MESSAGE'
  // });

  // cablecar.connect(store, 'MediaFileChannel', {
  //   params: { },
  //   prefix: 'CABLE_MEDIA_FILE'
  // });

  // cablecar.connect(store, 'VideoRoomChannel', {
  //   params: { },
  //   prefix: 'CABLE_VIDEO_ROOM'
  // });

  // cablecar.connect(store, 'BetChannel', {
  //   params: { },
  //   prefix: 'CABLE_BET'
  // });

  //<ErrorBoundary>
  const root = createRoot(node);

	root.render( 
      <Provider store={store}>
        <HashRouter history={history}>
          <WebsocketConnection/>
          <App /> 
        </HashRouter>
      </Provider>,
    node 
  );
});
